import { useEffect } from "react";
import { onOpenPreferencesPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { useUserStore } from "@/common/store";

export const useCheckPreferences = () => {
  const preferences = useUserStore((state) => state.currentUser?.preferences);

  useEffect(() => {
    if (preferences?.length === 0 || preferences === null) {
      onOpenPreferencesPopup();
    }
  }, [preferences]);
};
